import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'grommet';

import { greyLight } from '../../utils/colors';
import { MapProps } from './map.types';
import LazyWrappedMap from './LazyWrappedMap';

const Map: React.FC<MapProps> = ({ position, markers, zoom }) => {
  const [activated, setActivated] = useState(false);

  return (
    <MapContainer>
      {activated ? (
        <LazyWrappedMap position={position} markers={markers} zoom={zoom} />
      ) : (
        <>
          <Button
            onClick={() => setActivated(true)}
            type="button"
            label="Karte anzeigen"
          />
          <small>Für die Kartenansicht werden externe Inhalte geladen</small>
        </>
      )}
    </MapContainer>
  );
};

export default Map;

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 500px;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  background-color: ${greyLight};
`;
